import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { getImageUrl } from '../../config';
import useGifts from '../../hooks/useGifts';
import GiftImage, { getConditionBadgeClass } from '../common/GiftImage';
import { GiftGridSkeleton } from '../common/GiftCardSkeleton';
import '../common/GiftImage.css';
import '../common/GiftCardSkeleton.css';

function MainPage() {
    const { gifts, ready, syncing } = useGifts();
    const navigate = useNavigate();

    const formatDate = (timestamp) => {
        return new Date(timestamp * 1000).toLocaleDateString('en-US', {
            month: 'short', day: 'numeric', year: 'numeric'
        });
    };

    const showSkeleton = !ready && gifts.length === 0;

    return (
        <div className="page-container">
            <header className="page-header">
                <h1>Discover free gifts</h1>
                <p>Neighbors sharing household items they no longer need — browse, claim, and give things a second life.</p>
            </header>

            <div className="list-toolbar">
                <p className="list-toolbar__count">
                    <strong>{gifts.length}</strong> items available
                    {syncing && <span className="list-toolbar__sync"> · Updating…</span>}
                </p>
                <div className="list-toolbar__actions">
                    <Link to="/app/search" className="btn-gift btn-gift-secondary">Search & filter</Link>
                </div>
            </div>

            {showSkeleton ? (
                <GiftGridSkeleton count={6} />
            ) : gifts.length === 0 ? (
                <div className="empty-state">
                    <p>No listings available right now.</p>
                </div>
            ) : (
                <div className="gifts-grid">
                    {gifts.map((gift) => (
                        <article key={gift.id} className="gift-card">
                            <div className="gift-card__media">
                                <GiftImage
                                    name={gift.name}
                                    category={gift.category}
                                    imageUrl={getImageUrl(gift.image)}
                                    variant="card"
                                />
                            </div>
                            <div className="gift-card__body">
                                <h3 className="gift-card__title">{gift.name}</h3>
                                <div className="gift-card__meta">
                                    <span className={`badge-condition ${getConditionBadgeClass(gift.condition)}`}>
                                        {gift.condition}
                                    </span>
                                    <span className="badge-category">{gift.category}</span>
                                </div>
                                <p className="gift-card__date">Posted {formatDate(gift.date_added)}</p>
                                <div className="gift-card__footer">
                                    <button
                                        onClick={() => navigate(`/app/gift/${gift.id}`)}
                                        className="btn-gift btn-gift-primary"
                                    >
                                        View details
                                    </button>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            )}
        </div>
    );
}

export default MainPage;
